import React from "react";

/**
 * Sobrio: una línea horizontal, texto explicando qué va ahí, y la acción
 * principal. Nada de ícono gris dentro de un círculo pastel.
 */
export const EmptyState = ({ title, description, action, testId }) => (
  <div data-testid={testId || "empty-state"} className="flex flex-col items-start gap-4 px-6 py-16">
    <div className="h-px w-16 bg-line-strong" />
    <div>
      <h3 className="text-[15px] font-semibold text-ink">{title}</h3>
      {description && <p className="mt-1.5 max-w-md text-[15px] text-ink-secondary">{description}</p>}
    </div>
    {action}
  </div>
);
